import {
  type FC, useEffect, useState,
} from 'react';
import { useDispatch } from 'react-redux';
import { type SpreadsheetColumnId } from '../../_shared/types/spreadsheetData/spreadsheetColumn';
import { useTranslation } from '../../_shared/utils/hooks';
import { type ModalProps } from '../../modal/modalType.enum';
import { presentationalColumnsRestrictionsSetRestriction } from '../../store/presentationalColumnsRestrictions/presentationalColumnsRestrictions.actionCreators';
import { usePrimarySpreadsheetId } from '../../store/selectors/usePrimarySpreadsheetId';
import { PresentationalColumnsRestrictionsContainer } from '../presentationalColumnsRestrictions.container';
import { usePresentationalColumnsRestrictionsSettingsRows } from '../usePresentationalColumnsRestrictionsSettingsRows';

type PublicMapFiltersSettingsContainerProps = ModalProps<void>;

export const PublicMapColumnsDisplaySettingsContainer: FC<PublicMapFiltersSettingsContainerProps> = (props) => {
  const primarySpreadsheetId = usePrimarySpreadsheetId();
  const [selectedSpreadsheetId, setSelectedSpreadsheetId] = useState(primarySpreadsheetId);
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const { settingsRows: publicMapFiltersDisplaySettingsDataRows } =
    usePresentationalColumnsRestrictionsSettingsRows(selectedSpreadsheetId, 'master', t);

  const onToggleClick = (spreadsheetColumnId: SpreadsheetColumnId, newValue: boolean) => {
    dispatch(presentationalColumnsRestrictionsSetRestriction(spreadsheetColumnId, 'master', newValue));
  };

  useEffect(() => {
    setSelectedSpreadsheetId(primarySpreadsheetId);
  }, [primarySpreadsheetId]);

  return (
    <PresentationalColumnsRestrictionsContainer
      {...props}
      columnNameLabel={t('Your Data')}
      toggleColumnLabel={t('Enable/Disable Column')}
      modalTitle={t('Enable/Disable Columns on Public Map')}
      settingsDataRows={publicMapFiltersDisplaySettingsDataRows}
      onToggleClick={onToggleClick}
      selectedSpreadsheetId={selectedSpreadsheetId}
      onSelectedSpreadsheetIdChange={setSelectedSpreadsheetId}
    />
  );
};
